import { LoginAppModule } from './pages/login-app/login-app.module';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PagesComponent } from './pages/pages.component';
import { AuthGuard } from './core/guards/auth.guard';
import { PermissionGuard } from './core/guards/permission.guard';


const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  {
    path: '',
    component: PagesComponent,
    children: [
      { path: '', loadChildren: () => import('./pages/home/home.module').then(m => m.HomeModule), canActivate: [AuthGuard] },
      { path: 'home', loadChildren: () => import('./pages/home/home.module').then(m => m.HomeModule), canActivate: [AuthGuard] },
      { path: 'documents-list', loadChildren: () => import('./pages/documents/documents/documents.module').then(m => m.DocumentsModule), canActivate: [AuthGuard, PermissionGuard] },
      { path: 'logs-documents', loadChildren: () => import('./pages/logs/logs-list/logs-list.module').then(m => m.LogsListModule), canActivate: [AuthGuard, PermissionGuard] },
      { path: 'users', loadChildren: () => import('./pages/settings/user-list/user-list.module').then(m => m.UserListModule), canActivate: [AuthGuard, PermissionGuard] },
      { path: 'roles', loadChildren: () => import('./pages/settings/role-list/role-list.module').then(m => m.RoleListModule), canActivate: [AuthGuard, PermissionGuard] },
      { path: 'connections', loadChildren: () => import('./pages/settings/connection-list/connection-list.module').then(m => m.ConnectionListModule), canActivate: [AuthGuard, PermissionGuard] },
      { path: 'companies', loadChildren: () => import('./pages/settings/company-list/company-list.module').then(m => m.CompanyListModule), canActivate: [AuthGuard, PermissionGuard] },
      { path: 'logsViewer', loadChildren: () => import('./pages/logs/viewer/viewer.module').then(m => m.ViewerModule)},
    ],
  },
  { path: 'login', loadChildren: () => import('./pages/login-app/login-app.module').then(m => m.LoginAppModule) },
  { path: '**', loadChildren: () => import('./pages/home/home.module').then(m => m.HomeModule), canActivate: [AuthGuard] }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
